import { loadHlsVideo } from '../../utils/load_hls_video'

function initLoopingVideos() {
  loadHlsVideo('.video-looping').catch(error => {
    console.warn('Error loading HLS video for .video-looping:', error)
  })
}
initLoopingVideos()

$(function () {
  const $video = $('.js-header-video')

  if ($video.length === 0) return false

  const mp4_src = $video.data('mp4-src')
  const webm_src = $video.data('webm-src')

  $video.append(`<source src="${mp4_src}" type="video/mp4"><source src="${webm_src}" type="video/webm">`)
})
